import { render } from "./PR9-071422.vue?vue&type=template&id=6142f435"
import script from "./PR9-071422.vue?vue&type=script&lang=js"
export * from "./PR9-071422.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__